import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoQuoteLeft24 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path d="M10.0394 7.83333C10.0077 7.83304 9.9756 7.8359 9.94323 7.84221C9.89087 7.85249 7.95467 8.18678 6.61742 9.79324C5.48508 11.151 5.39992 12.496 5.33417 13.4646C5.3323 13.492 5.33473 13.5183 5.33651 13.5449C5.33639 13.5561 5.3351 13.5669 5.3351 13.5781C5.3351 14.9751 6.24881 16.6515 8.47739 16.6517C10.1819 16.6517 11.4941 15.3851 11.4941 13.5781C11.4941 12.3862 10.9584 10.5044 8.54837 10.5044C8.07526 10.5044 7.64369 10.5878 7.25952 10.7365C7.31993 10.6489 7.38321 10.5609 7.45144 10.4727C8.12544 9.60287 9.18617 9.00428 10.1464 8.77523C10.3938 8.71569 10.5529 8.47153 10.5036 8.21952C10.4593 7.99295 10.2616 7.83539 10.0394 7.83333ZM17.2122 7.83333C17.1805 7.83304 17.1484 7.8359 17.116 7.84221C17.0636 7.85249 15.1274 8.18678 13.7902 9.79324C12.6578 11.151 12.5727 12.496 12.5069 13.4646C12.5051 13.492 12.5075 13.5183 12.5093 13.5449C12.5092 13.5561 12.5079 13.5669 12.5079 13.5781C12.5079 14.9751 13.4216 16.6515 15.6502 16.6517C17.3546 16.6517 18.6668 15.3851 18.6668 13.5781C18.6668 12.3862 18.1312 10.5044 15.7211 10.5044C15.248 10.5044 14.8165 10.5878 14.4323 10.7365C14.4927 10.6489 14.556 10.5609 14.6242 10.4727C15.2982 9.60287 16.3589 9.00428 17.3191 8.77523C17.5666 8.71569 17.7256 8.47153 17.6764 8.21952C17.632 7.99295 17.4344 7.83539 17.2122 7.83333Z" fill={iconColor} />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoQuoteLeft24;